package dev.lingvo.site.components.marketing

/**
 * CLDR's plural rules for Russian, which is the whole trick.
 *
 * 1, 21, 31 … take `one` — twenty-one items is singular. 2–4 and 22–24 take `few`. The teens are the
 * exception that catches everyone: 11–14 take `many` despite ending in 1–4. `other` is reached only
 * by fractions, which is why an integer count never selects it.
 *
 * Written out rather than pulled from `pluralCategoriesFor`, because that function answers which
 * categories a locale *has*; this answers which one a given number *selects*, and only Russian is
 * needed here.
 *
 * **This file used to hold a whole second instrument, and nothing called it.** `PluralInstrument`
 * was the pre-Polyglot draft of what is now `PluralsBand.PluralsInstrument`; the redesign replaced
 * it and left it standing. Two live copies of one plural rule would be two copies to get wrong, and
 * a dead one is worse — it drew a coloured bar down the leading edge of the selected row, which is
 * the exact device `MultiplicationBand` and `FormatsBand` each write down as banned system-wide, so
 * the page's own precedent against that pattern had a working example of it sitting one file away.
 * It also carried five catalogue keys a translator could spend time on and no reader could ever
 * reach. What survives is the rule itself and the count the page opens on, which are the only two
 * things anything actually imported.
 */
internal fun russianPluralCategory(count: Int): String {
    val mod10 = count % 10
    val mod100 = count % 100
    return when {
        mod10 == 1 && mod100 != 11 -> "one"
        mod10 in 2..4 && mod100 !in 12..14 -> "few"
        else -> "many"
    }
}

/** Where the count starts, so the still frame is already the surprising fact. */
const val INSTRUMENT_INITIAL_COUNT = 21
